import * as React from 'react'
import { connect } from 'react-redux'

import { Box, IconButton, Menu, MenuItem } from '@design/pt-ui'
import { MoreVert as MoreVertIcon } from '@mui/icons-material'

import CallToAction from '../components/CallToAction'
import { Creative, CreativeAction } from '../interfaces/entities/creative'
import { Optionset } from '../interfaces/components/options'
import SomethingIcon from '../components/SomethingIcon'
import { getOption } from '../utils/get-option'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareSquare } from '@fortawesome/free-solid-svg-icons'
import { User } from '../interfaces/entities/user'
import { State } from '../model'
import { translateWithUserLocale } from '../utils/i18n'

const ITEM_HEIGHT = 48
interface ICreativeActions {
  creative: Creative
  user: User
  doCreativeAction: (creative: Creative, action: CreativeAction) => any
  formatsetType?: string
  onMenuClose?: () => any
  anchorEl?: any
}
interface IState {
  anchorEl: any
}

function CreativeActions(props: ICreativeActions) {
  const [state, setState] = React.useState<IState>({
    anchorEl: null,
  })

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setState((state) => ({ ...state, anchorEl: event.currentTarget }))
  }

  const handleClose = () => {
    if (props.onMenuClose) {
      props.onMenuClose()
    }
    setState((state) => ({ ...state, anchorEl: null }))
  }

  const handleClickOnAction = (action: CreativeAction) => {
    props.doCreativeAction(props.creative, action)
    handleClose()
  }
  const anchorEl = props.anchorEl || state.anchorEl
  const creative = props.creative

  const possibleActions = creative.possibleActions.filter(
    (action) => action.name !== 'finalize',
  )

  if (possibleActions.length === 0) {
    return null
  }

  const actionIcons: Optionset = [
    {
      archive: 'archive',
      delete: 'delete',
      reopen: 'repeat',
      send: 'send',
      duplicate: 'file_copy',
    },
    'build',
  ]

  const confirmationDialogTitle: Optionset = [
    {
      delete: translateWithUserLocale('confirmation_dialog.delete_title'),
      send: translateWithUserLocale('confirmation_dialog.send_title'),
      finalize:
        'Do you want to finalize the specification of your creative despite the existing warnings',
    },
    '',
  ]

  const confirmationDialogButtonName: Optionset = [
    {
      delete: 'Delete',
      send: translateWithUserLocale('confirmation_dialog.confirm_send'),
      finalize: 'Finalize',
    },
    '',
  ]

  const confirmationDialogMessage: Optionset = [
    {
      delete: translateWithUserLocale('confirmation_dialog.delete_message'),
      send: translateWithUserLocale('confirmation_dialog.send_message'),
      finalize: translateWithUserLocale('warning.finalize_with_long_input', {
        number: 40,
      }),
    },
    '',
  ]

  return (
    <Box
      className="cp-creative-actions-menu"
      sx={{
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'center',
        textAlign: 'right',
      }}>
      <IconButton
        aria-label="More"
        aria-owns={anchorEl != null ? 'cp-creative-actions-menu' : ''}
        aria-haspopup="true"
        onClick={handleClick}
        disableRipple={true}
        sx={{
          height: '30px',
          width: '30px',
          marginRight: 1.5,
          padding: 0,
        }}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="cp-creative-actions-menu"
        anchorEl={anchorEl != null ? anchorEl : undefined}
        open={anchorEl != null ? true : false}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 250,
          },
        }}>
        {possibleActions.map((action) => {
          return (
            <CallToAction
              className={`cp-cta-creative-${action.name}`}
              onClick={() => handleClickOnAction(action)}
              confirm={['delete', 'send', 'finalize'].includes(action.name)}
              dialog={{
                title: getOption(action.name, confirmationDialogTitle),
                yes: getOption(action.name, confirmationDialogButtonName),
                message: getOption(action.name, confirmationDialogMessage),
              }}
              key={action.name}>
              <MenuItem selected={false}>
                {action.name === 'broadcast' ? (
                  <FontAwesomeIcon icon={faShareSquare} />
                ) : (
                  <SomethingIcon id={action.name} icons={actionIcons} />
                )}
                <span style={{ marginLeft: 5 }}>{action.label}</span>
              </MenuItem>
            </CallToAction>
          )
        })}
      </Menu>
    </Box>
  )
}

const mapStateToProps = (state: State) => {
  return { user: state.user }
}

export default connect(mapStateToProps)(
  CreativeActions as any,
) as React.ComponentType<any>
